var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.consumeMode,
          expression: "!consumeMode",
        },
      ],
      staticClass: "cw-toolbar-wrapper",
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-toolbar",
          style: _vm.toolbarStyle,
          attrs: {
            id: "cw-toolbar",
          },
        },
        [
          _vm.showTools
            ? _c(
                "div",
                {
                  staticClass: "cw-toolbar-tools",
                  class: {
                    unfold: _vm.unfold,
                    hd: _vm.isHd,
                    wqhd: _vm.isWqhd,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cw-toolbar-button-wrapper",
                      attrs: {
                        id: "cw-toolbar-nav",
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "cw-toolbar-button",
                          class: {
                            active: _vm.activeTool === "blockAdder",
                          },
                          attrs: {
                            title: _vm.$gettext("Blöcke hinzufügen"),
                          },
                          on: {
                            click: function click($event) {
                              return _vm.activateTool("blockAdder")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$gettext("Blöcke")) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "cw-toolbar-button",
                          class: {
                            active: _vm.activeTool === "containerAdder",
                          },
                          attrs: {
                            title: _vm.$gettext("Abschnitte hinzufügen"),
                          },
                          on: {
                            click: function click($event) {
                              return _vm.activateTool("containerAdder")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$gettext("Abschnitte")) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "cw-toolbar-button",
                          class: {
                            active: _vm.activeTool === "clipboard",
                          },
                          attrs: {
                            title: _vm.$gettext("Block Merkliste"),
                          },
                          on: {
                            click: function click($event) {
                              return _vm.activateTool("clipboard")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$gettext("Merkliste")) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "cw-toolbar-button cw-toolbar-button-toggle",
                          attrs: {
                            title: _vm.$gettext("Werkzeugleiste einklappen"),
                          },
                          on: {
                            click: _vm.toggleToolbarActive,
                          },
                        },
                        [
                          _c("studip-icon", {
                            attrs: {
                              shape: "arr_2right",
                              size: 24,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cw-toolbar-tool-wrapper",
                    },
                    [
                      _vm.activeTool === "blockAdder"
                        ? _c("CoursewareToolbarBlocks", {
                            attrs: {
                              toolbarContentHeight: _vm.toolbarContentHeight,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeTool === "containerAdder"
                        ? _c("CoursewareToolbarContainers")
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeTool === "clipboard"
                        ? _c("CoursewareToolbarClipboard", {
                            attrs: {
                              toolbarContentHeight: _vm.toolbarContentHeight,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "cw-toolbar-folded-wrapper",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "cw-toolbar-button",
                      attrs: {
                        title: _vm.$gettext("Werkzeugleiste ausklappen"),
                      },
                      on: {
                        click: _vm.toggleToolbarActive,
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "arr_2left",
                          size: 24,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "cw-toolbar-button",
                      attrs: {
                        title: _vm.hideEditLayout
                          ? _vm.$gettext("Bearbeitungselemente anzeigen")
                          : _vm.$gettext("Bearbeitungselemente ausblenden"),
                      },
                      on: {
                        click: _vm.toggleHideEditLayout,
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: _vm.hideEditLayout
                            ? "visibility-checked"
                            : "visibility-invisible",
                          size: 24,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
          _vm._v(" "),
          _c("div", {
            staticClass: "cw-toolbar-spacer-right",
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }